export default __webpack_public_path__ + "059760669cbed8810887a88afd3c1a97.svg";